import { ButtonProps, Button as MuiButton, Tooltip, withStyles } from '@material-ui/core';
import React from 'react';

// Tooltip need this adjusted style to appear on a disabled button
const Button = withStyles({
  root: {
    '&.Mui-disabled': {
      pointerEvents: 'auto',
    },
  },
})(MuiButton);

type ButtonWithTooltipProps = ButtonProps & {
  tooltipText: string;
};

const ButtonWithTooltip: React.FC<ButtonWithTooltipProps> = ({ tooltipText, disabled, onClick, ...other }) => {
  // Tooltip need these adjusted props to appear on a disabled button
  const adjustedButtonProps = {
    disabled,
    component: disabled ? 'div' : undefined,
    onClick: disabled ? undefined : onClick,
  };

  return (
    <Tooltip title={tooltipText ? <span style={{ fontSize: '.8rem' }}>{tooltipText}</span> : ''}>
      <Button {...other} {...adjustedButtonProps} />
    </Tooltip>
  );
};

export default ButtonWithTooltip;
